
export default {
  description: {
    primary: "grey",
    error: "red",
  },
};
